@if (notification) {
  <div class="card-style mb-3 rounded-box px-4 py-2">
    <div class="flex w-full flex-row justify-between">
      <div class="error-text mb-2 flex flex-row gap-2 text-lg">
        <span aria-hidden="true" class="error-icon">
          <i class="fa-regular fa-circle-xmark text-xl"></i>
        </span>
        <span class="text-sm font-semibold leading-snug">
          {{ notification.message }} -
          <a class="cursor-pointer font-bold text-daisy-primary hover:underline"
            [routerLink]="['t', notification.tenantExternalId, 'system-configuration', 'integrations', 'processing-log']"
            (click)="onHyperLinkClick(notification, $event)" target="_blank" rel="noopener noreferrer">
            View
          </a>
        </span>
      </div>
      <div class="h-12 shrink-0">
        @if (notification.isRead) {
          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
            aria-label="Mark as unread" daisyTooltip="Mark as unread"
            (click)="onMarkNotificationsReadStatusesClick(notification, false, $event)">
            <i class="fa-regular fa-circle"></i>
          </button>
        } @else {
          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
            aria-label="Mark as read" daisyTooltip="Mark as read"
            (click)="onMarkNotificationsReadStatusesClick(notification, true, $event)">
            <i class="fa-solid fa-circle"></i>
          </button>
        }
      </div>
    </div>
    <span class="text-sm">
      {{ notification.content?.primaryText }}
    </span>
    <div class="my-1 flex items-center justify-between">
      <span class="font-mono text-xs opacity-70">
        {{ notification.content?.secondaryText }}
      </span>
      <span class="text-base-content/60">
        {{ notification.createdOn | timeAgo }}
      </span>
    </div>
  </div>
}
